export function Separator() {
    return <div className="h-[1px] bg-[rgba(255,255,255,0.03)] w-full" />
}
